import { Typography, Box } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { PageHeader } from '../components/PageHeader';
import { InvoiceForm } from '../components/InvoiceForm';
import { CreateInvoiceResponse } from '../services/payments-api.service';

export function InvoicesPage() {
    const handleInvoiceSuccess = (response: CreateInvoiceResponse) => {
        // Optional: Add any page-level success handling here
        // For now, the InvoiceForm handles its own success state
        console.log('Invoice created successfully:', response);
    };

    return (
        <PageHeader currentPath="/invoices">
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <ReceiptIcon sx={{ fontSize: 28, mt: 0.3, mr: 1.5, color: 'primary.main' }} />
                <Typography variant="h5" component="h1" fontWeight={600}>
                    Invoices
                </Typography>
            </Box>

            <InvoiceForm onSuccess={handleInvoiceSuccess} />
        </PageHeader>
    );
}
